import { render, staticRenderFns } from "./JobOpportunitiesTable.vue?vue&type=template&id=64cbbb9a&"
import script from "./JobOpportunitiesTable.vue?vue&type=script&lang=js&"
export * from "./JobOpportunitiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports